import { IntegrationCore } from 'types/Integration';
import { Maybe, Undef } from 'types/UtilityTypes';
import { TMS } from 'types/enums/Integrations';

export enum PlsWebEnvironment {
  Prod = 'prod',
  Uat = 'uat',
}

const PLS_WEB_HOST: Record<PlsWebEnvironment, string> = {
  [PlsWebEnvironment.Prod]: 'https://plsthree.pro',
  [PlsWebEnvironment.Uat]: 'https://uat.plsthree.pro',
};

export function plsWebEnvironmentFromTestingFlag(
  isTestingEnvironment: boolean
): PlsWebEnvironment {
  if (isTestingEnvironment) {
    return PlsWebEnvironment.Uat;
  }

  return PlsWebEnvironment.Prod;
}

// externalTMSID is the numeric PLS load id used by /load/#!/load/edit/{id}.
export function getPlsLoadEditURL(
  loadId: string,
  isTestingEnvironment: boolean
): Maybe<string> {
  const id = loadId.trim();
  if (!id) {
    return null;
  }

  const environment = plsWebEnvironmentFromTestingFlag(isTestingEnvironment);
  const host = PLS_WEB_HOST[environment];
  return `${host}/load/#!/load/edit/${encodeURIComponent(id)}`;
}

// CreateLoad can land on a different PLS row than the form's catalog integration.
export function plsCreateUsedTestingEnvironment(
  integrations: Undef<readonly IntegrationCore[]>,
  tmsID: Undef<number>
): boolean {
  if (tmsID == null) {
    return false;
  }

  const match = integrations?.find(
    (integration) => integration.name === TMS.PLS && integration.id === tmsID
  );
  return Boolean(match?.isTestingEnvironment);
}
